import { ProductInternalResponseDto, ProductNodeDto } from '@scip/api';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { translationKeys } from '../../../../../core';

@Component({
  selector: 'scip-dossier-summary',
  templateUrl: './dossier-summary.component.html',
  styleUrls: ['./dossier-summary.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DossierSummaryComponent {
  @Input() product: ProductInternalResponseDto;
  @Input() productNode: ProductNodeDto;

  translationKeys: typeof translationKeys = translationKeys;
}
